 $(($) => {
     $(".mega-menu li a").filter(function () {
            let firstSegment = this.href.split('/')[3];
             return firstSegment == location.pathname.split('/')[1];
         })
         .closest('li')
         .addClass("mega-current_page_item")
 });
